<template>
	<transition name="slide-up" transition-mode="out-in" enter-stagger="5000">
		<component :is="currentScreen"/>
	</transition>
</template>

<script>
	
	import Compass from "@/components/Compass";
	import LogIn from "@/components/LogIn";
	
	export default {
		
		name: "App",
		
		components: { Compass, LogIn },
		
		computed: {
			
			currentScreen() {
				if (this.$store.getters.loggedIn) {
					return "Compass";
				}
				return "LogIn";
			},
			
		},
		
		created() {
			
			//console.log(document);
			
			document.body.setAttribute("spellcheck", false);
			
			this.$auth.ready(function() {
				
				if (this.$auth.check()) {
					this.axios.get("startup").then((r) => {
						this.$store.commit("setApiData", { key: "clients", data: r.data.clients });
						this.$store.commit("setApiData", { key: "projects", data: r.data.projects });
						this.$store.commit("setApiData", { key: "users", data: r.data.users });
						this.$store.commit("loggedIn", this.$auth.check());
					});
				}
				
				/*setTimeout(() => {
					this.$store.commit("loggedIn", this.$auth.check());
				}, 1000);
				
				this.$store.dispatch("getApiData", { key: "clients" });
				
				this.$store.dispatch("getApiData", { key: "projects" });
				
				this.$store.dispatch("getApiData", { key: "users" });*/
				
			});
			
		},
		
	}
	
</script>

<style lang="scss">
	
	
	
</style>



// WEBPACK FOOTER //
// src/App.vue